// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0432348","455":"18c7d143","757":"b36b8f12","977":"87486d7a"}[chunkId] + ".chunk.js";
};